import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import {
  techDocsExpandableNavigationAddonModule,
  techDocsTextSizeAddonModule,
} from '@backstage/plugin-techdocs-module-addons-contrib/alpha';
import appRollupPlugin from '@internal/plugin-app-rollup';
import argoWorkflowsPlugin from '@internal/plugin-argo-workflows';
import changesPlugin from '@internal/plugin-changes';
import knowledgeGraphPlugin from '@internal/plugin-knowledge-graph';
import wireguardPlugin from '@internal/plugin-wireguard';
import { topologyCatalogModule } from '@backstage-community/plugin-topology/alpha';
import { argocdFeatures } from './modules/argocd';
import { authModule } from './modules/auth';
import { devopsModule } from './modules/devops';
import { environmentsPlugin } from './modules/environments';
import { qaPlugin } from './modules/qa';
import { releasesPlugin } from './modules/releases';
import { navModule } from './modules/nav';
import { themeModule } from './modules/theme';

export default createApp({
  features: [
    catalogPlugin,
    techdocsPlugin,
    techDocsExpandableNavigationAddonModule,
    techDocsTextSizeAddonModule,
    appRollupPlugin,
    argoWorkflowsPlugin,
    changesPlugin,
    knowledgeGraphPlugin,
    wireguardPlugin,
    ...argocdFeatures,
    environmentsPlugin,
    qaPlugin,
    releasesPlugin,
    topologyCatalogModule,
    devopsModule,
    navModule,
    themeModule,
    authModule,
  ],
});
